import BaseConfig from '../../common/config'
import { getWallData } from './configWalls/getWallData'
import { getQuotasSchedule } from '../helpers/quotaSchedule'

const Constantes = window.config.Constantes;
const { quota, enabledSegment } = getQuotasSchedule();

class PaywallConfig extends BaseConfig {
    constructor() {
        super();

        this.modo = null;
        this.combo = null;
        this.idWall = null;
        this.modoWallFamiliar = 'F';
        this.defaultModoRedirect = 'C';
        
        this.urlRedirect = Constantes.Dominios.checkout + "/C/";
        this.urlRedirectAccion = window.location.origin + "/suscripcion/A/";
        this.urlRedirectAccionVolunteer = window.location.origin + "/suscribirme";
        this.urlRedirectWall = (modo, combo) => (`${window.location.origin}/suscripcion/${modo}/${combo}/1/`);
        this.dominioIngresarDefault = Constantes.Dominios.login + "/login/ingresar/D/1/?callback=";
        
        this.dominioIngresar = Constantes.Dominios.login + "/login/ingresar/P/1/?callback=";
        this.dominioIngresarRegistracion = Constantes.Dominios.login + "/login/registracion/P/1/?callback=";
        this.idCookiePremium = "";

        this.dominioMiCuenta = Constantes.Dominios.micuenta;
        this.urlAvatar = Constantes.Dominios.static + "/images/avatar/";
        this.urlEdicionImpresa = Constantes.Dominios.lanacion + "/edicion-impresa";
        this.apiAuthorize = Constantes.Dominios.apiAuthorize;
        this.apiPaywall = Constantes.Dominios.apiPaywall;
        this.apiPaywallHub = Constantes.Dominios.apiPaywallHub;
        this.googleClientId = Constantes.gmId;
        this.DDClientToken = Constantes.DDClientToken;
        this.apiAuthorizeInfo = {
            cookieExpirationTime: Constantes.TimeExpiration,
            dominioCookie: Constantes.dominioCookie,
            CookiesMetering: Constantes.CookiesMetering
        };

        this.SitioOrigen = Constantes.SitioOrigen;

        this.PRODUCTO_NOTA = parseInt(Constantes.PRODUCTO_NOTA); // 1;
        this.PRODUCTO_PDF = parseInt(Constantes.PRODUCTO_PDF); //2;
        this.SegmentoDefault = Constantes.SegmentoDefault;
        this.Segmento = Constantes.Segmento;

        this.ACCION_YA_TIENE_SUSCRIPCION = 1;

        this.Routes = Constantes.Routes;

        this.debugMode = false;
        this.debugFlowData = {
            "A": {
                codeResult: "04",
                message: ""
            },
            "B": {
                codeResult: "04",
                message: ""
            },
            "C": {
                codeResult: "04",
                message: ""
            },
            "D": {
                codeResult: "05",
                message: ""
            },
            "E": {
                codeResult: "01",
                message: ""
            },
            "F": {
                codeResult: "20",
                message: ""
            }
        }

        this.defaultUrl = window.location.origin + '/suscripcion/' + this.defaultModo + '/' + this.defaultSitioId + '/?';


        // ==================================================
        // Modos permitidos
        // al agrtegar una entrada en el route automaticamente la configura como modo permitido
        // ==================================================      
        this.Modos = [];
        for (var x in this.Routes) { this.Modos.push(this.Routes[x].modo); }


        // ==================================================
        // Campañas permitidas 
        // 373 : Campaña bonificada
        // 374 : Campaña paga
        // ==================================================  
        this.campaniaBonificada = Constantes.campaniaBonificada;
        this.campaniaPaga = Constantes.campaniaPaga;
        
        this.COOKIE_GRUPO = 'controlGroupV3';
        this.COOKIE_METERING = 'metering_arc';
        this.COOKIE_COUNTER = 'metering_arc_counter';

        this.CUOTA = quota;
        this.SegmentoGroupEnabled = enabledSegment;


    }

    // ==================================================
    // Valida si el modo en la URL esta permitido (Se saca desde config.js)
    // ================================================== 
    modoPermitido = (modo) => this.Modos.includes(modo?.toUpperCase())
    

    // ==================================================
    // Valida si el sitio en la URL esta permitido (Se saca desde config.js)
    // ================================================== 
    sitioPermitido(sitio) {
        if (this.Sitios[sitio] == null) return false;
        return true;
    }

    setConfigWall(modo, combo = null){
        
        this.modo = modo;
        this.combo = combo;
        const idWall = combo !== null ? `${modo}_${combo}` : modo;
        const config = getWallData(idWall);
        if(config === null){
            console.error("Error al obtener config para wall");
            return;
        }
        this.idWall = idWall;
        this.dominioIngresar = Constantes.Dominios.login + config.pathIngresar;
        this.dominioIngresarRegistracion = Constantes.Dominios.login + config.pathRegistracion;
        this.idCookiePremium = config.idCookiePremium;
        this.favicon = config.favicon;
        this.hasBonificado = config.hasBonificado;
        this.defaultRedirectUrl = config.defaultRedirectUrl;
    }
}

const Config = new PaywallConfig();

module.exports = {
    Config
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/config.js